import { FC } from 'react';
import { useLocation, Location, Outlet } from 'react-router-dom';
import { getLeftBlockIcon } from 'view/pages/createJobPost/helpers';
import Step from '@mui/material/Step';
import { BackButton } from 'view/components';
import * as CS from 'view/pages/auth/commonStyled';
import { TUpdate } from 'domain/types';
import {
  CreateJobPostConfigContext,
  TCreateJobPostContextState,
} from 'domain/createJobPostConfig/CreateJobPostContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { createJobPostConfigSelectors } from 'domain/createJobPostConfig/selectors';
import * as S from './styled';

export const steps = [
  { label: 'Company Setup', path: '/create-job-post/setup' },
  { label: 'Job Information', path: '/create-job-post/step1' },
  { label: 'Job Details', path: '/create-job-post/step2' },
  { label: 'Qualifications and Skills', path: '/create-job-post/step3' },
  { label: 'Application Instructions', path: '/create-job-post/step5' },
];

const CreateJobPostLayout: FC = () => {
  const location: Location = useLocation();

  const update: TUpdate<TCreateJobPostContextState> | undefined = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.update
  );

  const createJobPostData = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.createJobPostData
  );

  const activeStep = steps.findIndex((step) => {
    return location.pathname.includes(step.path);
  });

  return (
    <S.Wrapper>
      <S.LeftBlock>
        <S.LeftBlockHeader>
          <CS.BackButtonBox>
            <BackButton
              text="Back to Home"
              color="#fff"
              onClick={() => {
                if (update) update({ isOpenBackToHomeModal: true });
              }}
            />
          </CS.BackButtonBox>
          <S.LeftBlockTitle>
            {createJobPostData?.editStatus ? 'Edit' : 'Create'} Job Post
          </S.LeftBlockTitle>
          <S.CustomStepper activeStep={activeStep} orientation="vertical">
            {steps.map((step) => {
              return (
                <Step key={step.label}>
                  <S.StepLabelText>{step.label}</S.StepLabelText>
                </Step>
              );
            })}
          </S.CustomStepper>
        </S.LeftBlockHeader>

        {getLeftBlockIcon(location)}
      </S.LeftBlock>
      <S.RightBlock>
        <Outlet />
      </S.RightBlock>
    </S.Wrapper>
  );
};

export default CreateJobPostLayout;
